import type { Plurals, Strings } from '../index';

export const strings: Strings = {
  'menu.home': 'Home',
  'menu.notes': 'Note',
  'menu.reminders': 'Promemoria',
  'menu.passwords': 'Password',
  'menu.cards': 'Carte',
  'menu.photoIds': 'Documenti d’identità',
  'menu.collections': 'Raccolte',
  'menu.conflicts': 'Conflitti ({count})',
  'menu.settings': 'Impostazioni',
  'menu.lock': 'Blocca il portafoglio',
  'menu.language': 'Lingua',

  'type.note': 'Nota',
  'type.note.plural': 'Note',
  'type.password': 'Password',
  'type.password.plural': 'Password',
  'type.card': 'Carta',
  'type.card.plural': 'Carte',
  'type.photoId': 'Documento d’identità',
  'type.photoId.plural': 'Documenti d’identità',

  'section.upcoming': 'Promemoria imminenti',
  'section.pinned': 'Fissati',
  'section.recent': 'Recenti',
  'section.searchResults': 'Risultati della ricerca',
  'section.conflicts': 'Conflitti',

  'action.addNew': '+ Aggiungi',
  'action.back': 'Indietro',
  'search.placeholder': 'Cerca o aggiungi',

  'gate.title': 'Tutto ciò che conta',
  'gate.copy': 'Il tuo portafoglio viene cifrato su questo dispositivo prima di qualsiasi sincronizzazione.',
  'gate.create': 'Crea un nuovo portafoglio',
  'gate.open': 'Apri il mio portafoglio esistente',
  'gate.recover': 'Recupera l’accesso al portafoglio',

  'empty.addFirst': 'Aggiungi il tuo primo elemento.',
  'empty.nothingHere': 'Qui non c’è ancora nulla.',
  'empty.noResults': 'Nessun elemento salvato corrisponde alla ricerca.',

  'action.cancel': 'Annulla',
  'action.save': 'Salva',
  'action.saving': 'Salvataggio…',
  'action.close': 'Chiudi',
  'action.edit': 'Modifica',
  'action.delete': 'Elimina',
  'action.remove': 'Rimuovi',
  'action.change': 'Modifica',
  'action.clear': 'Cancella',
  'action.add': 'Aggiungi',
  'action.show': 'Mostra',
  'action.hide': 'Nascondi',
  'action.more': 'Altro',

  'field.title': 'Titolo',
  'field.body': 'Testo',
  'field.username': 'Nome utente',
  'field.password': 'Password',
  'field.website': 'Sito web',
  'field.notes': 'Note',
  'field.cardNumber': 'Numero della carta',
  'field.documentNumber': 'Numero del documento',
  'field.expiry': 'Scadenza',
  'field.securityCode': 'Codice di sicurezza',
  'field.cvv': 'CVV / CVC',
  'field.pin': 'PIN',
  'field.documentType': 'Tipo di documento',
  'field.reminder': 'Promemoria',
  'field.collections': 'Raccolte',
  'field.idPhotos': 'Foto del documento',
  'field.attachments': 'Allegati',

  'editor.newItem': 'Nuovo: {type}',
  'editor.editItem': 'Modifica: {type}',
  'editor.titlePlaceholder': 'Titolo ({type})',
  'editor.selectDocumentType': 'Seleziona il tipo di documento',
  'editor.noneSelected': 'Nessuna selezione',
  'editor.optional': 'Facoltativo',
  'editor.optionalFields': 'Campi facoltativi',
  'editor.reminderDate': 'Data del promemoria',
  'editor.optionalTime': 'Ora (facoltativa)',
  'editor.shortcutHint': 'Ctrl+Invio salva. Esc annulla.',
  'editor.addTitle': 'Aggiungi un titolo.',
  'editor.saveFailed': 'Impossibile salvare questo elemento.',
  'editor.photoFailed': 'Impossibile preparare questa foto.',
  'editor.attachmentFailed': 'Impossibile preparare questo allegato.',
  'editor.photoNote': 'Le foto fino a {mb} MB vengono cifrate e salvate su questo dispositivo, poi sincronizzate automaticamente se la sincronizzazione è attiva.',
  'editor.attachmentNote': 'I file vengono cifrati esattamente come selezionati e salvati su questo dispositivo. Safe Wallet blocca i tipi di file eseguibili, script, web attivi e con macro più comuni, ma non esegue una scansione antivirus.',
  'editor.attachmentButton': 'Allegato (max {mb} MB)',
  'editor.addingAttachment': 'Aggiunta dell’allegato…',
  'editor.preparing': 'Preparazione…',
  'editor.takePhoto': 'Scatta una foto',
  'editor.choosePhoto': 'Scegli una foto',
  'editor.front': 'Fronte',
  'editor.back': 'Retro',
  'editor.tapAddFront': 'Tocca per aggiungere il fronte',
  'editor.tapAddBack': 'Tocca per aggiungere il retro',
  'editor.photoNotOnDevice': 'La foto cifrata non è salvata su questo dispositivo.',
  'editor.pinItem': 'Fissa',
  'editor.pinned': 'Fissato',
  'editor.deleteItem': 'Elimina elemento',

  'viewer.noBody': 'Nessun testo.',
  'viewer.notSet': 'Non impostato',
  'viewer.escCloses': 'Esc chiude questa vista.',

  'attach.title': 'Allegato',
  'attach.notOnDevice': 'L’allegato cifrato non è ancora salvato su questo dispositivo.',
  'attach.photoNotOnDevice': 'La foto cifrata non è ancora salvata su questo dispositivo.',
  'attach.openingPhoto': 'Apertura della foto cifrata…',
  'attach.opening': 'Apertura…',
  'attach.notStored': 'Non salvato su questo dispositivo',
  'attach.couldNotOpen': 'Impossibile aprire questo allegato.',
  'attach.previewUnavailable': 'Anteprima non disponibile per questo tipo di file. Scaricalo e aprilo con un’app di cui ti fidi.',
  'attach.previewLimited': 'Anteprima limitata al primo MB.',
  'attach.openPdf': 'Apri il PDF',
  'attach.download': 'Scarica',

  'expiry.label': 'Scadenza (MM/AA)',
  'expiry.month': 'Mese di scadenza',
  'expiry.chooseMonthYear': 'Scegli mese e anno',
  'expiry.chooseDate': 'Scegli la data di scadenza',
  'expiry.previousYear': 'Anno precedente',
  'expiry.nextYear': 'Anno successivo',

  'collections.createFirst': 'Crea prima le raccolte dal menu principale.',
  'chooser.addNew': 'Aggiungi',

  'settings.title': 'Impostazioni',
  'settings.account': 'Account',
  'settings.security': 'Sicurezza',
  'settings.recovery': 'Recupero',
  'settings.thisDevice': 'Questo dispositivo',
  'settings.appearance': 'Aspetto',
  'settings.searchPrivacy': 'Privacy della ricerca',
  'settings.dangerZone': 'Area critica',
  'settings.notSignedIn': 'Non connesso',
  'settings.pinOnly': 'Solo PIN',
  'settings.pinAndFingerprint': 'PIN + impronta',
  'settings.changePinRow': 'Cambia il PIN dell’app su questo dispositivo. È necessario il PIN attuale.',
  'settings.lockNow': 'Blocca ora',
  'settings.chooseAnotherWallet': 'Scegli un altro portafoglio',
  'settings.useAnotherAccount': 'Usa un altro account',
  'settings.categoryLabels': 'Etichette delle categorie',
  'settings.rowSpacing': 'Spaziatura delle righe',
  'settings.textSize': 'Dimensione del testo',
  'settings.autoLock': 'Blocco automatico',
  'settings.optionName': 'Nome',
  'settings.optionIcon': 'Icona',
  'settings.optionBoth': 'Entrambi',
  'settings.optionLarge': 'Grande',
  'settings.optionMedium': 'Media',
  'settings.optionCompact': 'Compatta',
  'settings.optionSmall': 'Piccola',
  'settings.searchPrivacyNote': 'L’indice di ricerca decifrato esiste solo su questo dispositivo sbloccato e viene cancellato quando il portafoglio si blocca. Password, PIN, numeri di carta e di conto, codici di sicurezza, numeri di documento, codici di recupero e segreti simili non vengono mai indicizzati.',
  'settings.exampleProjection': 'Esempio per il primo elemento',
  'settings.noItemsYet': 'Ancora nessun elemento.',
  'settings.removeWalletNote': 'Rimuovere questo portafoglio da questo browser non elimina la copia cifrata nell’account.',
  'settings.removeWallet': 'Rimuovi questo portafoglio locale',

  'pin.changeTitle': 'Cambia il PIN dell’app',
  'pin.change': 'Cambia PIN',
  'pin.changing': 'Modifica in corso…',
  'pin.current': 'PIN attuale',
  'pin.new': 'Nuovo PIN',
  'pin.repeat': 'Ripeti il nuovo PIN',
  'pin.accountPassword': 'Password dell’account',
  'pin.accountPasswordHint': 'Serve per aggiornare l’accesso sugli altri dispositivi.',
  'pin.noteSynced': 'I tuoi elementi salvati non devono essere cifrati di nuovo. Poiché questo portafoglio si sincronizza, serve la password dell’account affinché il nuovo PIN funzioni anche accedendo da un nuovo dispositivo.',
  'pin.noteLocal': 'Il PIN attuale sblocca questo portafoglio su questo dispositivo. I tuoi elementi salvati non devono essere cifrati di nuovo.',
  'pin.errCurrent': 'Inserisci il PIN attuale dell’app, da 6 a 12 cifre.',
  'pin.errNew': 'Usa un nuovo PIN dell’app da 6 a 12 cifre.',
  'pin.errMismatch': 'I due nuovi PIN non coincidono.',
  'pin.errSame': 'Scegli un nuovo PIN diverso da quello attuale.',
  'pin.errPassword': 'Inserisci la password del tuo account.',
  'pin.errFailed': 'Impossibile cambiare il PIN dell’app.',

  'fingerprint.title': 'Sblocco con impronta',
  'fingerprint.settingUp': 'Configurazione…',
  'fingerprint.unavailable': 'Questo dispositivo non può farlo.',
  'fingerprint.errOn': 'Impossibile attivare questa opzione.',
  'fingerprint.errOff': 'Impossibile disattivare questa opzione.',

  'sync.off': 'Disattivata — solo su questo dispositivo',
  'sync.notConfigured': 'Disattivata — sincronizzazione non configurata',
  'sync.connecting': 'Connessione…',
  'sync.uploading': 'Attiva — sincronizzazione della copia cifrata…',
  'sync.waiting': 'Attiva — modifiche cifrate in attesa di invio',
  'sync.connected': 'Attiva — copia cifrata collegata',
  'sync.offline': 'Offline — copia cifrata in pausa',

  'account.signedIn': 'Connesso',
  'account.signedInAs': 'Connesso come',
  'account.anotherAccount': 'Un altro account',
  'account.currentAccount': 'Account attuale',
  'account.wallet': 'Portafoglio',
  'account.sync': 'Sincronizzazione',
  'account.device': 'Dispositivo',
  'account.signOut': 'Esci',
  'account.signOutOf': 'Esci da {account}',
  'account.email': 'E-mail',
  'account.pinLabel': 'PIN di Safe Wallet',
  'account.pinHint': 'Il PIN di questo portafoglio. Se l’account ha già un portafoglio, usa il PIN di quello.',
  'account.pinPlaceholder': 'da 6 a 12 cifre',
  'account.signInTab': 'Accedi',
  'account.createTab': 'Crea un account',
  'account.forgotPassword': 'Password dell’account dimenticata?',
  'account.signInSync': 'Accedi e sincronizza',
  'account.createSync': 'Crea un account e sincronizza',
  'account.signInSyncTitle': 'Accesso e sincronizzazione',
  'account.differentSession': 'In questo browser è connesso un account, ma questo portafoglio locale non è collegato a quell’account. Apri “Accesso e sincronizzazione” qui sotto per collegare l’account proprietario di questo portafoglio, oppure esci prima per usarne un altro.',
  'account.notConfigured': 'La sincronizzazione non è configurata per questa installazione.',
  'account.confirmEmail': 'Conferma l’account dall’e-mail, poi torna qui e accedi. Questo portafoglio locale non è ancora collegato.',
  'account.errPin': 'Inserisci il PIN di Safe Wallet di questo portafoglio, da 6 a 12 cifre.',
  'account.errSession': 'Non è stato possibile stabilire la sessione dell’account.',
  'account.connected': 'Portafoglio collegato. La sincronizzazione sta per iniziare.',
  'account.connectedNoSync': 'Account collegato. La sincronizzazione non è disponibile in questo ambiente.',
  'account.errConnect': 'Impossibile collegare questo account.',
  'account.resetSent': 'Controlla la tua e-mail per il link di reimpostazione della password.',
  'account.errReset': 'Impossibile inviare l’e-mail di reimpostazione.',
  'account.signedOut': 'Disconnesso dall’account. Il portafoglio cifrato resta disponibile su questo dispositivo.',

  'pairing.advanced': 'Avanzate: approva un altro dispositivo',
  'pairing.advancedNote': 'Usalo solo quando il normale accesso con password e PIN non è disponibile. Confronta l’impronta su entrambi i dispositivi prima di approvare.',
  'pairing.none': 'Nessun dispositivo in attesa.',
  'pairing.invalidKey': 'Chiave di associazione non valida',
  'pairing.calculating': 'Calcolo dell’impronta…',
  'pairing.review': 'Verifica',
  'pairing.reviewTitle': 'Verifica il nuovo dispositivo',
  'pairing.fingerprint': 'Impronta di verifica',
  'pairing.compare': 'Confronta ogni gruppo con l’impronta mostrata sul nuovo dispositivo.',
  'pairing.doNotApprove': 'Non approvare in caso di differenze.',
  'pairing.mismatchNote': 'Potrebbe significare che la chiave di associazione è stata modificata e che la chiave del portafoglio potrebbe essere inviata al dispositivo sbagliato.',
  'pairing.confirm': 'Ho confrontato entrambe le impronte e coincidono esattamente.',
  'pairing.approve': 'Approva il dispositivo',
  'pairing.approving': 'Approvazione…',
  'pairing.approved': '{device} approvato.',
  'pairing.errInvalid': 'Questa richiesta di approvazione contiene una chiave di associazione non valida. Rifiutala e avvia una nuova richiesta.',
  'pairing.errChanged': 'La chiave di associazione è cambiata durante la verifica. Annulla questa richiesta.',
  'pairing.errApprove': 'Impossibile approvare quel dispositivo.',

  'wallet.localOnly': 'Portafoglio solo locale',
  'wallet.lastUsedRecently': 'Usato di recente',
  'wallet.notConnected': 'Non collegato a un account',
  'wallet.availableOnDevice': 'Portafoglio disponibile su questo dispositivo',
  'wallet.onlyThisDevice': 'Solo su questo dispositivo — sincronizzazione disattivata',

  'fingerprint.confirmBackup': 'Attivare lo sblocco con impronta?\n\nDa ora in poi, per aprire questo portafoglio su questo dispositivo serviranno sia l’impronta sia il PIN. Se un giorno l’impronta smettesse di funzionare, potrai rientrare con l’accesso di riserva o tramite un contatto fidato.',
  'fingerprint.confirmNoBackup': 'Attivare lo sblocco con impronta?\n\nDa ora in poi, per aprire questo portafoglio su questo dispositivo serviranno sia l’impronta sia il PIN. Questo portafoglio non ha ancora una copia di riserva: se l’impronta smettesse di funzionare non potrebbe più essere aperto. Si consiglia vivamente di attivare prima la sincronizzazione.',

  'gate.cloudNotConfigured': 'Il cloud non è ancora configurato. Puoi creare ora un portafoglio locale e collegarlo più tardi dalle impostazioni.',

  'create.title': 'Crea il PIN dell’app',
  'create.intro': 'Il PIN sblocca questo dispositivo. La password dell’account sarà separata quando attiverai la sincronizzazione.',
  'create.walletName': 'Nome del portafoglio',
  'create.walletNameHint': 'Mostrato in questo browser prima di inserire il PIN.',
  'create.walletNamePlaceholder': 'Alex, Sam, Cassaforte di famiglia…',
  'create.deviceName': 'Nome del dispositivo',
  'create.appPin': 'PIN dell’app',
  'create.repeatPin': 'Ripeti il PIN',
  'create.creating': 'Creazione…',
  'create.createWallet': 'Crea il portafoglio',
  'create.errPin': 'Usa un PIN dell’app da 6 a 12 cifre.',
  'create.errMismatch': 'I due PIN non coincidono.',
  'create.errFailed': 'Impossibile creare questo portafoglio.',
  'create.errHello': 'Impossibile attivare lo sblocco con impronta.',
  'create.fingerprintTitle': 'Aggiungere impronta o volto?',
  'create.fingerprintCopy': 'Una seconda serratura, così una copia rubata del tuo portafoglio non può essere forzata. Continuerai comunque a inserire il PIN.',
  'create.turnOn': 'Attiva',
  'create.notNow': 'Non ora',

  'unlock.title': 'Sblocca Safe Wallet',
  'unlock.unlock': 'Sblocca',
  'unlock.opening': 'Apertura…',
  'unlock.withFingerprint': 'Sblocca con l’impronta',
  'unlock.wait': 'Attendi {seconds}s',
  'unlock.tooManyAttempts': 'Troppi tentativi. Riprova tra {seconds}s.',
  'unlock.tooMany': 'Troppi PIN errati',
  'unlock.tooManyBackup': 'Prenditi un momento. Puoi continuare a provare qui sotto oppure recuperare l’accesso con l’accesso di riserva o un contatto fidato.',
  'unlock.tooManyLocal': 'Prenditi un momento e riprova con attenzione. Questo portafoglio è solo su questo dispositivo, quindi non esiste una copia di riserva.',
  'unlock.forgotPin': 'Hai dimenticato il PIN di Safe Wallet?',
  'unlock.errFailed': 'Impossibile aprire questo portafoglio.',

  'chooser.chooseWallet': 'Scegli un portafoglio',
  'chooser.eachHasPin': 'Ogni portafoglio salvato ha il proprio PIN in questo browser.',
  'chooser.current': 'Attuale',
  'chooser.addAnother': 'Aggiungi un altro account',

  'existing.title': 'Portafoglio esistente',
  'existing.heading': 'Apri il mio portafoglio',
  'existing.intro': 'Usa la password dell’account e il PIN di Safe Wallet per aprire questo portafoglio su questo dispositivo.',
  'existing.openWallet': 'Apri il portafoglio',
  'existing.forgotPin': 'Hai dimenticato il PIN di Safe Wallet?',
  'existing.advanced': 'Avanzate: approva da un altro dispositivo',
  'existing.advancedNote': 'Da usare solo per i vecchi portafogli beta non ancora aggiornati per l’accesso con password e PIN.',
  'existing.requesting': 'Richiesta in corso…',
  'existing.requestApproval': 'Richiedi l’approvazione del dispositivo',
  'existing.approvalTitle': 'Approvazione del dispositivo',
  'existing.unavailable': 'Non disponibile',
  'existing.calculating': 'Calcolo…',
  'existing.mismatchNote': 'Una differenza significa che la chiave di associazione potrebbe essere stata modificata durante il trasferimento. Annulla la richiesta e non approvarla.',
  'existing.cancelRequest': 'Annulla la richiesta',
  'existing.approved': 'Dispositivo approvato',
  'existing.setPin': 'Imposta un PIN',
  'existing.setPinNote': 'Questo PIN protegge la chiave del portafoglio approvata su questo dispositivo. Puoi usare lo stesso PIN di Safe Wallet degli altri tuoi dispositivi personali.',
  'existing.finishing': 'Completamento…',
  'existing.errPin': 'Usa un PIN di Safe Wallet da 6 a 12 cifre.',
  'existing.errNoWallet': 'Questo account non ha ancora un Safe Wallet. Crea invece un nuovo portafoglio.',
  'existing.errUpgrade': 'È necessario un aggiornamento una tantum. Apri questo portafoglio una volta su un dispositivo dove funziona già, attiva lì la sincronizzazione e riprova.',
  'existing.errRequest': 'Impossibile richiedere l’approvazione del dispositivo.',
  'existing.errCancel': 'Impossibile annullare la richiesta di approvazione; scadrà automaticamente.',
  'existing.errFinish': 'Impossibile completare l’approvazione del dispositivo.',
  'existing.errPairingInvalid': 'La chiave di associazione locale non è valida. Annulla e avvia una nuova richiesta.',
  'existing.errCancelled': 'Quella richiesta di approvazione è stata annullata. Avvia una nuova richiesta.',
  'existing.errExpired': 'Quella richiesta di approvazione è scaduta. Avvia una nuova richiesta.',

  'status.onDeviceOnly': 'Solo su questo dispositivo',
  'status.syncing': 'Sincronizzazione…',
  'status.synced': 'Sincronizzato',
  'status.offline': 'Offline',
  'status.saving': 'Salvataggio…',
  'status.savingLocal': 'Salvataggio su questo dispositivo…',
  'status.openingDatabase': 'Apertura del database locale…',
  'status.couldNotStart': 'Avvio non riuscito',
  'status.errInit': 'Impossibile avviare Safe Wallet.',
  'status.errDatabase': 'Il database locale non è pronto.',
  'menu.closeMenu': 'Chiudi il menu',
  'action.showAll': 'Mostra tutto',

  'conflict.collection': 'Raccolta',
  'conflict.deletedVersion': 'Una versione eliminata è in conflitto con un’altra modifica',
  'conflict.multipleChanges': 'Più modifiche offline',
  'conflict.title': 'Conflitto',
  'conflict.chooseVersion': 'Scegli la versione da mantenere',
  'conflict.note': 'Entrambe le versioni cifrate vengono conservate finché non scegli. Una versione eliminata può essere scelta di proposito.',
  'conflict.loading': 'Caricamento delle versioni…',
  'conflict.deleted': 'Versione eliminata',
  'conflict.resolving': 'Risoluzione…',
  'conflict.keepDeleted': 'Mantieni eliminata',
  'conflict.useThis': 'Usa questa versione',
  'conflict.errOpen': 'Impossibile aprire le versioni in conflitto.',
  'conflict.errResolve': 'Impossibile risolvere questo conflitto.',
  'conflict.screenNote': 'Le modifiche fatte offline su più dispositivi restano cifrate e vengono conservate finché non scegli quale versione mantenere.',
  'conflict.none': 'Nessun conflitto.',

  'collections.newName': 'Nome della nuova raccolta',
  'collections.note': 'Le raccolte sono cartelle private. Un elemento può appartenere a più raccolte.',
  'collections.confirmDelete': 'Eliminare la raccolta “{name}”? Gli elementi restano in Safe Wallet.',

  'item.confirmDelete': 'Eliminare “{title}”? Potrà essere ripristinato dalla cronologia della copia di riserva per un periodo limitato.',
  'reminder.confirmDone': 'Segnare questo promemoria come completato?\n\nLa data del promemoria resta sull’elemento.',
  'reset.confirmOther': 'Rimuovere “{name}” da questo browser? La copia cifrata nell’account non viene eliminata e gli altri portafogli su questo browser restano intatti. Per aggiungerlo di nuovo qui serviranno l’account di riserva e il PIN.',
  'reset.confirmLast': 'Rimuovere questo portafoglio locale da questo browser? I dati cifrati già sincronizzati non vengono eliminati dall’account. Le modifiche ancora in attesa di invio e l’approvazione del dispositivo per questo browser verranno cancellate.',

  'merge.confirmAdd': 'Questo account ha già un portafoglio. Vuoi aggiungervi i tuoi {items}, comprese foto e file, e passare a quel portafoglio?\n\nIl portafoglio attuale resta su questo browser finché non lo rimuovi.',
  'merge.notice': 'Aggiunti {items}, comprese le loro foto e i file, a questo portafoglio. Il vecchio portafoglio “{name}” è ancora su questo browser. Quando la copia di riserva sarà stata caricata, potrai rimuoverlo qui sotto.',
  'merge.removeOld': 'Rimuovi il vecchio portafoglio',
  'merge.backingUp': 'Copia in corso…',
  'merge.dismiss': 'Chiudi',
  'merge.confirmRemoveOld': 'Rimuovere il vecchio portafoglio “{name}” da questo browser?\n\nI suoi elementi sono già stati copiati in questo portafoglio e salvati nel tuo account. Questo cancella solo la vecchia copia locale su questo browser.',
  'merge.errMismatch': 'Il portafoglio che si è aperto non corrisponde all’account scelto per la copia. Dal portafoglio originale non è stato rimosso nulla.',
  'merge.errOpenLocal': 'Apri il portafoglio locale prima di aggiungere i suoi elementi a un altro portafoglio.',
  'merge.errNoWallet': 'Questo account non ha un portafoglio a cui aggiungere elementi.',
  'merge.errKeyPackage': 'Apri una volta il portafoglio dell’account sul dispositivo dove funziona già, poi riprova.',
  'merge.errPin': 'Quel PIN non apre il portafoglio già presente su questo account. Inserisci il PIN di quel portafoglio.',

  'pin.errNoSync': 'La sincronizzazione non è configurata, quindi il PIN non può essere aggiornato per i nuovi dispositivi.',
  'pin.errNoEmail': 'Per questo portafoglio non è registrata alcuna e-mail dell’account su questo dispositivo.',
  'pin.errOffline': 'Sembra che tu sia offline. Riconnettiti per cambiare il PIN usato per accedere da nuovi dispositivi.',
  'pin.errWrongPassword': 'La password dell’account non è corretta.',
  'pin.errDeviceUnavailable': 'Questo dispositivo non è disponibile.',
  'pin.changedBoth': 'PIN cambiato su questo dispositivo e per l’accesso da nuovi dispositivi.',
  'pin.changedLocal': 'PIN dell’app cambiato. Usa il nuovo PIN la prossima volta che questo dispositivo si blocca.',

  'recover.accountTitle': 'Account Safe Wallet',
  'recover.passwordChanged': 'Password cambiata',
  'recover.passwordChangedNote': 'Accedi di nuovo con la nuova password dell’account. Il PIN dell’app e il tuo portafoglio cifrato non sono stati modificati.',
  'recover.continue': 'Continua',
  'recover.choosePassword': 'Scegli una nuova password',
  'recover.choosePasswordNote': 'Questo cambia solo la password dell’account di sincronizzazione. Il PIN dell’app resta invariato e da sola questa password non apre il tuo portafoglio cifrato su un nuovo dispositivo.',
  'recover.checkingLink': 'Verifica del link di recupero…',
  'recover.newPassword': 'Nuova password dell’account',
  'recover.repeatPassword': 'Ripeti la nuova password',
  'recover.updating': 'Aggiornamento…',
  'recover.updatePassword': 'Aggiorna la password',
  'recover.errShort': 'Usa almeno 8 caratteri.',
  'recover.errMismatch': 'Le due password non coincidono.',
  'recover.errUpdate': 'Impossibile aggiornare la password dell’account.',

  'recover.walletTitle': 'Recupero del portafoglio',
  'recover.freshVerification': 'Recuperare un portafoglio richiede sempre una nuova verifica del tuo account. Safe Wallet non chiede mai il tuo codice a un contatto fidato.',
  'recover.useOnlyWhen': 'Usalo solo se nessuno dei tuoi dispositivi può reimpostare il PIN. Servono una nuova verifica via e-mail e l’approvazione di un contatto Safe Wallet fidato.',
  'recover.accountEmail': 'E-mail dell’account',
  'recover.emailCode': 'Codice di verifica ricevuto per e-mail',
  'recover.sendAnother': 'Invia un altro codice',
  'recover.authenticator': 'App di autenticazione',
  'recover.authenticatorCode': 'Codice dell’app di autenticazione',
  'recover.verifyStart': 'Verifica l’e-mail e inizia',
  'recover.verifyContinue': 'Verifica l’e-mail e continua',
  'recover.deviceFingerprint': 'Impronta del dispositivo che sta recuperando',
  'recover.readFingerprint': 'Leggi questa impronta al tuo contatto fidato durante una chiamata dal vivo. Deve chiamarti a un recapito che aveva già — mai a un numero che gli è stato inviato per l’occasione.',
  'recover.status': 'Stato:',
  'recover.waitingEnds': 'Il periodo di attesa termina:',
  'recover.expires': 'Scade:',
  'recover.cancel': 'Annulla il recupero',
  'recover.setNewPin': 'Imposta un nuovo PIN',
  'recover.keyRebuilt': 'La chiave del tuo portafoglio è stata ricostruita solo in questo browser. La protezione di recupero è ora esaurita e va configurata di nuovo.',
  'recover.deviceName': 'Nome del dispositivo',
  'recover.newPin': 'Nuovo PIN dell’app',
  'recover.repeatPin': 'Ripeti il PIN',

  'invite.securityConfirmation': 'Conferma di sicurezza',
  'invite.title': 'Invito al recupero',
  'invite.helpSomeone': 'Aiuta una persona di cui ti fidi',
  'invite.invitedBy': 'Invitato da',
  'invite.askedYou': 'Questa persona ti ha chiesto di essere il suo contatto fidato per il recupero.',

  'invite.cannotSee': 'Non puoi vedere il suo portafoglio.',
  'invite.cannotSeeNote': 'Ciò che vi è salvato resta cifrato e privato.',
  'invite.cannotRecover': 'Non puoi recuperarlo da solo.',
  'invite.cannotRecoverNote': 'Intervieni solo dopo che è la persona stessa ad avviare il recupero.',
  'invite.nothingToRemember': 'Non devi ricordare nulla.',
  'invite.nothingToRememberNote': 'Safe Wallet prepara tutto in sicurezza non appena accetti.',
  'invite.enterPin': 'Inserisci il tuo PIN',
  'invite.confirming': 'Conferma in corso…',
  'invite.decline': 'Rifiuta',
  'invite.accept': 'Accetta l’invito',
  'invite.confirmWithPin': 'Conferma con il tuo PIN',
  'invite.acceptTitle': 'Accetta l’invito al recupero',
  'invite.confirmBecome': 'Conferma che vuoi diventare contatto di recupero per:',
  'invite.declineTitle': 'Rifiuta l’invito',
  'invite.declineQuestion': 'Non diventare contatto di recupero?',
  'invite.invitationFrom': 'L’invito da',
  'invite.keep': 'Conserva l’invito',
  'invite.accepted': 'Invito accettato',
  'invite.nowContact': 'Ora sei un contatto di recupero',
  'invite.nothingUnless': 'Non devi fare nulla, a meno che',
  'invite.inboxTitle': 'Inviti al recupero',
  'invite.review': 'Esamina l’invito',
  'invite.errConfirm': 'Impossibile confermare.',
  'invite.errAccept': 'Impossibile accettare questo invito.',
  'invite.errDecline': 'Impossibile rifiutare questo invito.',

  'protect.preparing': 'Preparazione della protezione di recupero…',
  'protect.addPerson': 'Aggiungi una persona fidata',
  'protect.addPersonNote': 'Una persona fidata può aiutarti a rientrare nel tuo portafoglio. Non può vedere il tuo portafoglio né recuperarlo senza di te.',
  'protect.addSoYouCan': 'Aggiungi una persona fidata per poter rientrare se perdi il PIN o il dispositivo.',
  'protect.mustHaveAccount': 'Deve già avere un account Safe Wallet.',
  'protect.useTheirEmail': 'Usa l’indirizzo e-mail collegato al suo Safe Wallet.',
  'protect.emailLabel': 'E-mail Safe Wallet della persona fidata',
  'protect.emailPlaceholder': 'nome@esempio.it',
  'protect.send': 'Invia l’invito',
  'protect.yourPeople': 'Le tue persone fidate',
  'protect.onlyYouSee': 'Solo tu puoi vedere questo elenco.',
  'protect.waiting': 'In attesa che accetti',
  'protect.pending': 'In sospeso',
  'protect.canHelp': 'Può aiutarti quando chiedi il recupero',
  'protect.active': 'Attiva',
  'protect.protectionActive': 'La protezione di recupero è attiva',
  'protect.becomesActive': 'La protezione di recupero entra in funzione quando una persona invitata accetta.',
  'protect.errLoad': 'Impossibile caricare la protezione di recupero.',
  'protect.errSelf': 'Scegli un altro utente Safe Wallet.',
  'protect.errNoAccount': 'Nessun account Safe Wallet trovato per questa e-mail. Chiedi a questa persona di creare e confermare prima il proprio account.',
  'protect.errNotReady': 'Questo account Safe Wallet non è ancora pronto per gli inviti al recupero. Chiedi a questa persona di aprire e sbloccare una volta il suo Safe Wallet aggiornato, poi riprova.',
  'protect.errCheck': 'Impossibile verificare questo account Safe Wallet.',
  'protect.errSend': 'Impossibile inviare questo invito.',
  'invite.willBeRemoved': 'verrà rimosso. Potrà invitarti di nuovo più avanti.',
  'invite.asksForHelp': 'chiede aiuto per rientrare nel suo portafoglio.',
  'protect.notSetUp': 'Non configurata',
  'protect.checking': 'Verifica…',
  'reminder.done': 'Fatto',
  'reminder.doneOn': 'Fatto il {date}',
  'invite.enterWalletPin': 'Inserisci il PIN di Safe Wallet',
  'invite.confirmInviteNote': 'Conferma che vuoi invitare questa persona come contatto di recupero.',
  'invite.confirmInvite': 'Conferma l’invito',
  'recover.startTitle': 'Avvia il recupero',
  'recover.continueTitle': 'Continua il recupero',
  'invite.invitedYouTo': 'ti ha invitato a essere il suo contatto fidato per il recupero.',
  'approve.inboxTitle': 'Qualcuno ha bisogno del tuo aiuto',
  'approve.isRecovering': 'sta cercando di rientrare nel proprio portafoglio.',
  'approve.review': 'Esamina la richiesta',
  'approve.title': 'Autorizzi il rientro?',
  'approve.fingerprintLabel': 'Codice mostrato sul suo nuovo dispositivo',
  'approve.callFirst': 'Telefonale prima — a un numero che avevi già, mai a uno che ti è stato inviato. Fatti leggere il codice sul suo schermo e controlla che coincida esattamente con questo.',
  'approve.onlyIfSure': 'Autorizza solo se il codice coincide e sei sicuro che sia davvero lei. Se non lo è, avvisala subito così può annullare la richiesta.',
  'approve.approve': 'I codici coincidono — autorizza',
  'approve.approving': 'Autorizzazione…',
  'approve.notNow': 'Non ora',
  'approve.done': 'Autorizzato. Ora può rientrare.',
  'approve.errApprove': 'Impossibile autorizzare questa richiesta.',
  'approve.waitUntil': 'Potrà continuare dalle {time}.',
};

export const plurals: Plurals = {
  items: { one: '{count} elemento', other: '{count} elementi' },
  minutes: { one: '{count} minuto', other: '{count} minuti' },
  queued: { one: '{count} modifica in attesa', other: '{count} modifiche in attesa' },
  helpers: { one: '{count} persona fidata pronta ad aiutare.', other: '{count} persone fidate pronte ad aiutare.' },
};
